import { Link } from "react-router-dom";
import EnlaceCotizar from "../components/ui/EnlaceCotizar.jsx";
import { useCarrito } from "../lib/CarritoContext.jsx";
import { soles, numero } from "../lib/format";
import { IGV } from "../lib/config";
import s from "./Comercio.module.css";

export default function Carrito() {
  const {
    items,
    subtotal,
    igv,
    total,
    pesoTotal,
    cambiarCantidad,
    quitar,
    vaciar,
  } = useCarrito();

  if (items.length === 0) {
    return (
      <div className={`container ${s.vacio}`}>
        <p className="eyebrow">Carrito</p>
        <h1 className={s.vacioTitulo}>Tu carrito esta vacio</h1>
        <p className={s.vacioTexto}>
          Agrega productos desde el catalogo o envianos tu lista de materiales
          y te preparamos la cotizacion.
        </p>
        <div className={s.vacioAcciones}>
          <Link to="/productos" className="btn btn--accent">
            Ir al catalogo
          </Link>
          <EnlaceCotizar className="btn btn--ghost">
            Enviar mi lista
          </EnlaceCotizar>
        </div>
      </div>
    );
  }

  return (
    <div className={`container ${s.pagina}`}>
      <header className={s.cabeceraPagina}>
        <p className="eyebrow">Carrito</p>
        <h1 className={s.tituloPagina}>Tu pedido</h1>
      </header>

      <div className={s.layout}>
        <section className={s.lineas}>
          <div className={s.encabezadoTabla}>
            <span>Producto</span>
            <span>Cantidad</span>
            <span>Importe</span>
            <span className="visually-hidden">Acciones</span>
          </div>

          {items.map((i) => (
            <article key={i.id} className={s.linea}>
              <div className={s.lineaInfo}>
                <p className={`mono ${s.lineaSku}`}>{i.sku}</p>
                <h2 className={s.lineaNombre}>
                  <Link to={`/productos/${i.id}`}>{i.nombre}</Link>
                </h2>
                <p className={s.lineaUnitario}>
                  {soles(i.precio)} / {i.unidad}
                </p>
              </div>

              <div className={s.lineaCantidad}>
                <button
                  type="button"
                  onClick={() => cambiarCantidad(i.id, i.cantidad - 1)}
                  aria-label={`Restar una unidad de ${i.nombre}`}
                >
                  &minus;
                </button>
                <input
                  type="number"
                  min="1"
                  className="mono"
                  value={i.cantidad}
                  onChange={(e) => cambiarCantidad(i.id, e.target.value)}
                  aria-label={`Cantidad de ${i.nombre}`}
                />
                <button
                  type="button"
                  onClick={() => cambiarCantidad(i.id, i.cantidad + 1)}
                  aria-label={`Sumar una unidad de ${i.nombre}`}
                >
                  +
                </button>
              </div>

              <p className={`mono ${s.lineaImporte}`}>
                {soles((i.precio ?? 0) * i.cantidad)}
              </p>

              <button
                type="button"
                className={s.quitar}
                onClick={() => quitar(i.id)}
                aria-label={`Quitar ${i.nombre} del carrito`}
              >
                Quitar
              </button>
            </article>
          ))}

          <div className={s.piePedido}>
            <button type="button" className="btn btn--ghost btn--sm" onClick={vaciar}>
              Vaciar carrito
            </button>
            <Link to="/productos" className={s.seguir}>
              &larr; Seguir comprando
            </Link>
          </div>
        </section>

        <aside className={s.resumen}>
          <h2 className={s.resumenTitulo}>Resumen</h2>

          <dl className={s.resumenLista}>
            <div>
              <dt>Subtotal</dt>
              <dd className="mono">{soles(subtotal)}</dd>
            </div>
            <div>
              <dt>IGV ({Math.round(IGV * 100)}%)</dt>
              <dd className="mono">{soles(igv)}</dd>
            </div>
            {pesoTotal > 0 && (
              <div>
                <dt>Peso estimado</dt>
                <dd className="mono">{numero(pesoTotal, "kg")}</dd>
              </div>
            )}
            <div className={s.resumenTotal}>
              <dt>Total</dt>
              <dd className="mono">{soles(total)}</dd>
            </div>
          </dl>

          <p className="hint">
            El flete se calcula al confirmar la direccion de entrega.
          </p>

          <div className={s.resumenAcciones}>
            <Link to="/checkout" className="btn btn--accent btn--block">
              Continuar
            </Link>
            <EnlaceCotizar className="btn btn--ghost btn--block">
              Pedir cotizacion formal
            </EnlaceCotizar>
          </div>
        </aside>
      </div>
    </div>
  );
}
